import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { wordTranslations } from './data';
import * as Styled from './WordsMarquee.styles';

const MarqueeGroup = ({ groupKey, words }) => (
  <Styled.Group>
    {words.map((word, index) => (
      <Styled.Item key={`${groupKey}-${index}`}>
        <Styled.Word variant="h2" component="span">
          {word}
        </Styled.Word>

        <Styled.Logo src="/icons/hudd-logo-mini.svg" alt="logo" aria-hidden />
      </Styled.Item>
    ))}
  </Styled.Group>
);

const WordsMarquee = () => {
  const { i18n } = useTranslation();

  const words = useMemo(() => {
    const lang = i18n.resolvedLanguage || i18n.language;

    return wordTranslations.map((entry) => entry[lang] || entry.no);
  }, [i18n]);

  return (
    <Styled.WordsMarquee>
      <Styled.Viewport>
        <Styled.Track className="marquee-track">
          <MarqueeGroup groupKey="a" words={words} />
          <MarqueeGroup groupKey="b" words={words} />
        </Styled.Track>
      </Styled.Viewport>
    </Styled.WordsMarquee>
  );
};

export default WordsMarquee;
